<template>
    <a :href="url" class="page-arrow" :class="{
        next: next,
        prev: !next,
    }" @click.stop.prevent="click">
    <svg v-if="next" class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path></svg>
    <svg v-else class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"></path></svg>
        
    </a>
</template>
<script setup>
defineProps({
    next: {
        type: Boolean,
        default: false,
    },
    url: {
        type: String,
        default: ''
    }
})
const emits = defineEmits(['click'])

const click = () => {
    emits('click')
}
</script>
<style scoped lang="scss">
.page-arrow {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    border: 1px solid #E6E8EC;
    &.prev {
        margin-right: 6px;
    }
    &.next {
        margin-left: 6px;
    }
    .svg {
        width: 12px;
        height: 12px;
    }
    background: white;
    @media (any-hover:hover) {
        &:hover {
            background: #e6e8ec;
        }
    }
}
</style>

